import React from 'react'
import { honeyGenerator } from './honey'

type ConsentProps = {
  consentRef: React.RefObject<HTMLInputElement>
  text: string
  formStyle?: string
  formId?: string
  checkboxStyle?: 'blue' | 'orange'
}

const Consent: React.FC<ConsentProps> = ({
  consentRef,
  text,
  formStyle,
  formId,
  checkboxStyle,
}) => {
  const [checked, setChecked] = React.useState(false);
  let checkboxColorClass =
    checkboxStyle === 'orange' ? 'policy-consent__info--orange' : ''
  const consentHash = typeof formId === "string" && formId.length > 0 ? formId : honeyGenerator()
  const consentId = `AgreeWithTerms${consentHash}`

  return (
    <div className={`policy-consent ${formStyle ? formStyle : ""}`}>
      <input
        id={consentId}
        name={consentId}
        type="checkbox"
        className={`policy-consent__info ${checkboxColorClass}`}
        ref={consentRef}
        checked={checked}
        onChange={() => setChecked(!checked)}
        required
      />
      <label
        htmlFor={consentId}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  )
}

export default Consent
